import React from 'react';
import Dropdown from '../../components/Dropdown/Dropdown';
import SearchableDropdown from '../../components/SearchableDropdown/SearchableDropdown';
import './CourseSelect.css';

// A teacher with a handful of courses picks from a plain list; past this a search box earns its place.
const SEARCH_FROM = 8;

/**
 * CourseSelect — the course field of the teacher pages (students, metrics, Q&A). It sits in the
 * page header's action slot, the same place on all three, so the course reads as the context of the
 * page and not as one more filter. A short list is a <Dropdown>; a long one a <SearchableDropdown>
 * (which lists every course: its `pageSize` is the list length, so none is cut off).
 *
 *   <CourseSelect courses={courses} value={courseId} onChange={selectCourse}
 *                 ariaLabel="Kursni tanlang" getLabel={(course) => course.title} />
 */
function CourseSelect({ courses, value, onChange, getLabel, ariaLabel, placeholder, className = '' }) {
  const label = getLabel || ((course) => course.title || course.name || course.id);
  const classes = `tc-select${className ? ` ${className}` : ''}`;

  if (courses.length > SEARCH_FROM) {
    return (
      <div className={classes}>
        <SearchableDropdown
          items={courses}
          selectedId={value}
          onChange={onChange}
          getLabel={label}
          ariaLabel={ariaLabel}
          placeholder={placeholder}
          pageSize={Math.max(courses.length, 20)}
        />
      </div>
    );
  }

  return (
    <div className={classes}>
      <Dropdown
        value={value}
        onChange={onChange}
        options={courses.map((course) => ({ value: course.id, label: label(course) }))}
        ariaLabel={ariaLabel}
        placeholder={placeholder}
      />
    </div>
  );
}

export default CourseSelect;
